import styled from "styled-components";

export const PoolWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
